import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';
import { USER_PROFILE } from '../../../constants/define/translation';

export const UserProfileHeader = () => {
  const { t } = useTranslation(USER_PROFILE);

  return (
    <div>
      <ContentPageHeader title={t('header.title')} />
    </div>
  );
};
